import React, { memo } from 'react';
export function Comparison() {
  return <section className="bg-crema py-10 sm:py-16 px-5" data-id="element-70">
      <div className="max-w-[860px] mx-auto" data-id="element-71">
        <div className="text-center mb-8 sm:mb-12" data-id="element-72">
          <h2 className="text-[clamp(22px,4vw,34px)] font-extrabold leading-[1.2] mb-3 text-oscuro uppercase" data-id="element-73">
            LA REALIDAD
          </h2>
          <p className="text-[15px] text-gris" data-id="element-74">¿Cuánto te cuesta NO tenerlo?</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 rounded-2xl overflow-hidden shadow-[0_6px_30px_rgba(0,0,0,0.1)] max-w-[800px] mx-auto" data-id="element-75">
          <div className="bg-[#F3F3F3] p-7" data-id="element-76">
            <h4 className="text-[15px] font-extrabold mb-5 text-center uppercase tracking-wider text-gris" data-id="element-77">
              ❌ Sin el kit
            </h4>
            <div className="flex flex-col" data-id="element-78">
              <div className="text-[13px] py-2 border-b border-black/5 flex items-start gap-2 leading-[1.45] text-oscuro" data-id="element-79">
                <span className="flex-shrink-0 text-[15px]" data-id="element-80">😩</span>
                Respondés precios por chat, sin contexto ni formato profesional
              </div>
              <div className="text-[13px] py-2 border-b border-black/5 flex items-start gap-2 leading-[1.45] text-oscuro" data-id="element-81">
                <span className="flex-shrink-0 text-[15px]" data-id="element-82">🧠</span>
                Confiás en tu memoria para recordar qué tratamiento le hiciste a
                cada clienta
              </div>
              <div className="text-[13px] py-2 border-b border-black/5 flex items-start gap-2 leading-[1.45] text-oscuro" data-id="element-83">
                <span className="flex-shrink-0 text-[15px]" data-id="element-84">📉</span>
                No sabés cuánto ganás realmente a fin de mes
              </div>
              <div className="text-[13px] py-2 border-b border-black/5 flex items-start gap-2 leading-[1.45] text-oscuro" data-id="element-85">
                <span className="flex-shrink-0 text-[15px]" data-id="element-86">😰</span>
                No subís los precios por miedo a perder clientas
              </div>
              <div className="text-[13px] py-2 border-b border-black/5 flex items-start gap-2 leading-[1.45] text-oscuro" data-id="element-87">
                <span className="flex-shrink-0 text-[15px]" data-id="element-88">🔇</span>
                Los presupuestos quedan en el visto sin seguimiento
              </div>
              <div className="text-[13px] py-2 border-b border-black/5 flex items-start gap-2 leading-[1.45] text-oscuro" data-id="element-89">
                <span className="flex-shrink-0 text-[15px]" data-id="element-90">📱</span>
                Publicás en redes cuando te acordás, sin plan ni resultados
              </div>
              <div className="text-[13px] py-2 border-b border-black/5 flex items-start gap-2 leading-[1.45] text-oscuro" data-id="element-91">
                <span className="flex-shrink-0 text-[15px]" data-id="element-92">❌</span>
                Cancelaciones sin consecuencias ni política clara
              </div>
              <div className="text-[13px] py-2 flex items-start gap-2 leading-[1.45] text-oscuro" data-id="element-93">
                <span className="flex-shrink-0 text-[15px]" data-id="element-94">📅</span>
                Fin de mes igual que el anterior — sin crecimiento visible
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-rosa to-rosa-oscuro text-white p-7" data-id="element-95">
            <h4 className="text-[15px] font-extrabold mb-5 text-center uppercase tracking-wider" data-id="element-96">
              ✅ Con el kit
            </h4>
            <div className="flex flex-col" data-id="element-97">
              <div className="text-[13px] py-2 border-b border-white/15 flex items-start gap-2 leading-[1.45]" data-id="element-98">
                <span className="flex-shrink-0 text-[15px]" data-id="element-99">💅</span>
                Presupuesto PDF profesional enviado en 10 minutos desde el
                primer día
              </div>
              <div className="text-[13px] py-2 border-b border-white/15 flex items-start gap-2 leading-[1.45]" data-id="element-100">
                <span className="flex-shrink-0 text-[15px]" data-id="element-101">📋</span>
                Ficha de clienta completa con historial, objetivos y seguimiento
                de sesiones
              </div>
              <div className="text-[13px] py-2 border-b border-white/15 flex items-start gap-2 leading-[1.45]" data-id="element-102">
                <span className="flex-shrink-0 text-[15px]" data-id="element-103">📊</span>
                Planilla mensual que muestra ingresos, gastos y ganancia neta en
                5 min/semana
              </div>
              <div className="text-[13px] py-2 border-b border-white/15 flex items-start gap-2 leading-[1.45]" data-id="element-104">
                <span className="flex-shrink-0 text-[15px]" data-id="element-105">💰</span>
                Método de aumento en 2 etapas con el mensaje exacto para
                comunicarlo
              </div>
              <div className="text-[13px] py-2 border-b border-white/15 flex items-start gap-2 leading-[1.45]" data-id="element-106">
                <span className="flex-shrink-0 text-[15px]" data-id="element-107">📨</span>
                Guión de seguimiento a 24hs, 3 días y 7 días — listo para copiar
              </div>
              <div className="text-[13px] py-2 border-b border-white/15 flex items-start gap-2 leading-[1.45]" data-id="element-108">
                <span className="flex-shrink-0 text-[15px]" data-id="element-109">📲</span>
                Calendario de 30 ideas de contenido y plan semanal sostenible
              </div>
              <div className="text-[13px] py-2 border-b border-white/15 flex items-start gap-2 leading-[1.45]" data-id="element-110">
                <span className="flex-shrink-0 text-[15px]" data-id="element-111">✅</span>
                Política de seña y condiciones por escrito desde el primer turno
              </div>
              <div className="text-[13px] py-2 flex items-start gap-2 leading-[1.45]" data-id="element-112">
                <span className="flex-shrink-0 text-[15px]" data-id="element-113">📈</span>
                Sistema de fidelización que multiplica ingresos con las mismas
                clientas
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}